import { SmallDonutCard } from "~/components/SmallDonut";
import { useMetrics } from "~/hooks";
import { Metrics } from "~/lib/arrow";
import { CveIcon } from "~/icons";
import { DonutChartCardProps } from "~/pages/space/home-dashboard/components/types";

export function HomeDashboardCVEsDonutChart({ scope }: DonutChartCardProps) {
  const { cvesSeverity, isLoading } = useMetrics({
    entityMrn: scope?.mrn || "",
    metricMrns: [Metrics.CVEsSeverity],
  });

  return (
    <SmallDonutCard
      to={`/space/findings/cves?${scope?.params?.toString()}`}
      loading={isLoading}
      data={cvesSeverity}
      data-testid="cves-donut-chart"
      title="CVES"
      icon={<CveIcon />}
    />
  );
}
